import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { ButterflyIcon } from "../../components/public/ButterflyIcon";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.success) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#F7F0E8] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="bg-white rounded-[2px] p-8 w-full max-w-sm border border-[#090708]/8">
        <div className="flex flex-col items-center mb-6">
          <div className="flex items-center gap-2.5 mb-3">
            <ButterflyIcon className="w-9" />
            <div>
              <p className="text-sm uppercase tracking-[0.25em] font-normal text-[#9B6179] leading-tight whitespace-nowrap">Studio Carolina Aguiar</p>
              <p className="text-[9px] uppercase tracking-[0.2em] text-[#090708]/40 leading-tight">Estética Facial e Corporal</p>
            </div>
          </div>
          <p className="text-xs uppercase tracking-widest text-[#6F3F55] mt-1">Painel Administrativo</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>E-mail</Label><Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-input-email" /></div>
          <div><Label>Senha</Label><Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-input-password" /></div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <Button disabled={loading} type="submit" className="w-full bg-[#090708] text-[#E8C47A] rounded-[2px] hover:bg-[#6F3F55] transition-colors" data-testid="login-submit-button">
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
